import _ from 'lodash';
import React from 'react';

import {connect} from 'react-redux';

import {default as Modal, withModal} from 'components/Modal';
import StatusBox from 'components/StatusBox';

import {
  MODALS,
  GOCARDLESS_PAYMENT_STATUSES,
  fetchGocardlessPayment,
  fetchGocardlessPaymentEventsHistory,
  cancelGocardlessPayment,
  retryGocardlessPayment,
  SCHEDULE_TYPES
} from 'ducks/tenancy';

import {composeActions} from 'ducks/common';
import {PaymentInfo, PaymentDetails, PaymentHistory} from './components';

import {MODALS as BASE_MODALS, closeModal, openModal} from 'ducks/modals';

import './styles.css';

class GocardlessPaymentDetailModal extends React.Component<any> {
  componentDidMount() {
    const {data: {gocardlessPaymentId}} = this.props;
    this.props.fetchGocardlessPayment(
      {gocardlessPaymentId},
      this.getFetchGocardlessPaymentExtraActions()
    );

    const fetchGocardlessPaymentEventsHistoryExtraAction = this.props.storeDataExtraActions(
      data => ({
        gocardlessPaymentEventsHistory: data
      })
    );
    this.props.fetchGocardlessPaymentEventsHistory(
      {gocardlessPaymentId},
      fetchGocardlessPaymentEventsHistoryExtraAction
    );
  }

  getFetchGocardlessPaymentExtraActions = () =>
    this.props.storeDataExtraActions(data => ({
      gocardlessPayment: data
    }));

  openConfirmationModal = ({heading, confirmAction, question}) =>
    this.props.openModal(BASE_MODALS.CONFIRM, {
      heading,
      question,
      confirmAction
    });

  openPaymentDetailModal = (scheduleType, paymentId) => {
    const {locationRef, tenancyId} = this.props.data;
    this.props.composeActions([
      () => closeModal(MODALS.GOCARDLESS_PAYMENT_DETAIL),
      () =>
        openModal(
          MODALS.PAYMENT_DETAIL,
          {
            scheduleType: SCHEDULE_TYPES[scheduleType],
            paymentId,
            locationRef,
            tenancyId
          },
          true
        )
    ]);
  };

  openGocardlessCustomerModal = gocardlessCustomerId => {
    const {locationRef, tenancyId} = this.props.data;

    this.props.composeActions([
      () => closeModal(MODALS.GOCARDLESS_PAYMENT_DETAIL),
      () =>
        openModal(
          MODALS.GOCARDLESS_CUSTOMER_DETAIL,
          {
            gocardlessCustomerId,
            locationRef,
            tenancyId
          },
          true
        )
    ]);
  };

  cancelGocardlessPaymentConfirmAction = () => {
    const {data: {gocardlessPaymentId, scheduleType, tenancyId}} = this.props;

    const extraActions = [
      () => closeModal(BASE_MODALS.CONFIRM),
      () =>
        fetchGocardlessPayment(
          {gocardlessPaymentId},
          this.getFetchGocardlessPaymentExtraActions()
        ),
      () => this.props.refetchExtraActions({tenancyId, scheduleType})
    ];

    this.props.cancelGocardlessPayment({gocardlessPaymentId}, extraActions);
  };

  cancelGocardlessPayment = () =>
    this.openConfirmationModal({
      heading: 'Cancel GoCardless Payment',
      question: 'Are you sure you want to cancel this GoCardless payment?',
      confirmAction: this.cancelGocardlessPaymentConfirmAction
    });

  retryGocardlessPaymentConfirmAction = () => {
    const {data: {gocardlessPaymentId, scheduleType, tenancyId}} = this.props;

    const extraActions = [
      () => closeModal(BASE_MODALS.CONFIRM),
      () =>
        fetchGocardlessPayment(
          {gocardlessPaymentId},
          this.getFetchGocardlessPaymentExtraActions()
        ),
      () => this.props.refetchExtraActions({tenancyId, scheduleType})
    ];
    this.props.retryGocardlessPayment({gocardlessPaymentId}, extraActions);
  };

  retryGocardlessPayment = () =>
    this.openConfirmationModal({
      heading: 'Retry GoCardless Payment',
      question: 'Are you sure you want to retry this GoCardless payment?',
      confirmAction: this.retryGocardlessPaymentConfirmAction
    });

  render() {
    const gocardlessPayment = _.get(this.props, 'data.gocardlessPayment');
    const gocardlessPaymentEventsHistory = _.get(
      this.props,
      'data.gocardlessPaymentEventsHistory'
    );

    return (
      <div>
        {gocardlessPayment && (
          <Modal
            show={true}
            onClose={this.props.closeModal}
            className="GocardlessPaymentDetailModal"
            type={Modal.MEDIUM}>
            <Modal.Header>
              <h3 className="heading">GoCardless Payment</h3>
              <StatusBox
                color={
                  GOCARDLESS_PAYMENT_STATUSES[gocardlessPayment.status.value]
                    .color
                }
                status={gocardlessPayment.status.verbose}
              />
            </Modal.Header>
            <Modal.Body>
              <PaymentInfo
                gocardlessPayment={gocardlessPayment}
                cancelGocardlessPayment={this.cancelGocardlessPayment}
                retryGocardlessPayment={this.retryGocardlessPayment}
              />
              <PaymentDetails
                gocardlessPayment={gocardlessPayment}
                openPaymentDetailModal={this.openPaymentDetailModal}
                openGocardlessCustomerModal={this.openGocardlessCustomerModal}
              />
              <PaymentHistory
                gocardlessPaymentEventsHistory={gocardlessPaymentEventsHistory}
              />
            </Modal.Body>
          </Modal>
        )}
        {!gocardlessPayment && null}
      </div>
    );
  }
}

const mapDispatchToProps = {
  fetchGocardlessPayment,
  fetchGocardlessPaymentEventsHistory,
  cancelGocardlessPayment,
  retryGocardlessPayment,
  openModal,
  composeActions
};

export default connect(null, mapDispatchToProps)(withModal(
  MODALS.GOCARDLESS_PAYMENT_DETAIL
)(GocardlessPaymentDetailModal) as React.ComponentType<any>);
